import moment from 'moment'
import { PencilOff } from 'lucide-react'
import './DetailDates.scss'

const DetailDates = ({
  studyDetails = null,
}) => {

  const formatDate = (value) => {
    if (value) {
      if (Array.isArray(value)) {
        value = value[0]
      }
      return moment(value).format("DD-MMM-YYYY")
    }
    return 'N/A'
  }

  const formatResultsDate = (connex_data) => {
    if (connex_data?.results_first_submitted || connex_data?.pending_results_submitted) {
      let newResultsPostedDate = null;

      if (studyDetails?.ctg_data?.results_first_submitted) {
        newResultsPostedDate = studyDetails?.ctg_data?.results_first_submitted
      }
      else if (connex_data?.pending_results_submitted) {
        if (Array.isArray(connex_data?.pending_results_submitted)) {
          newResultsPostedDate = connex_data?.pending_results_submitted[0]
        } else {
          newResultsPostedDate = connex_data?.pending_results_submitted
        }
      }

      if (newResultsPostedDate) {
        return moment(newResultsPostedDate).format("DD-MMM-YYYY")
      } else {
        return 'N/A'
      }
    }
    return 'N/A'
  }

  const dateField = (label, value) => (
    <div>
      <label className="detail-dates__field-label">{label}</label>
      <div className="detail-dates__field-value">
        {value}
        <PencilOff />
      </div>
    </div>
  )

  return (
    <div className="detail-dates__grid">
      {dateField('Synced with CTG on', formatDate(studyDetails?.synced_at))}
      {dateField('Results Posted on', formatDate(studyDetails?.ctg_data?.results_first_posted))}
      {dateField('Results First Submitted on', formatResultsDate(studyDetails?.ctg_data))}
      {dateField('Results First Submitted QC on', formatDate(studyDetails?.ctg_data?.results_first_submitted_qc))}
      {dateField('Last Update Submitted on', formatDate(studyDetails?.ctg_data?.last_update_submitted))}
      {dateField('Last Update Submitted QC on', formatDate(studyDetails?.ctg_data?.last_update_submitted_qc))}
      {dateField('Last Update Posted on', formatDate(studyDetails?.ctg_data?.last_update_posted))}
    </div>
  );
}

export default DetailDates;
